var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import CarinaModal from '@cvent/carina/components/Modal';
import { css } from '@emotion/react';
export function Modal(props) {
    return (_jsx(CarinaModal, __assign({}, props, { css: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        @media (min-width: 1024px) {\n          width: calc((90vh - 382px) * 16 / 9);\n          max-width: 100vw;\n          height: 90vh;\n          min-width: 900px;\n        }\n      "], ["\n        @media (min-width: 1024px) {\n          width: calc((90vh - 382px) * 16 / 9);\n          max-width: 100vw;\n          height: 90vh;\n          min-width: 900px;\n        }\n      "]))) })));
}
var templateObject_1;
//# sourceMappingURL=Modal.js.map